<template>
  <div id="appNavbar">
   <v-layout wrap justify-end class="hidden-md-and-down">
      <v-flex lg12 align-self-center>
        <v-app-bar
        color="transparent"
          elevation="0"
          height="60px"
          class="hidden-md-and-down"
        >
          <v-layout wrap justify-center fill-height>
            <v-spacer></v-spacer>
            <v-flex xs6 lg2 xl1 pl-4 text-right align-self-center style="cursor:pointer">
              <AccountMenu />
            </v-flex>
          </v-layout>
        </v-app-bar>
      </v-flex>
    </v-layout>
    <v-layout wrap class="hidden-lg-and-up">
      <v-flex xs12>
        <v-app-bar
      app
      color="white"
      dense
      flat 
      height="50px"
      class="hidden-lg-and-up"
    >
    <v-layout wrap>
      <v-flex xs2>
        <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon color="#3F033B">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      </v-flex>
      <v-flex xs8 align-self-center text-left pl-2>
        <router-link to="/">
            <span
                  style="
                    font-family: GillSansUltraBold;
                    color: #3F033B;
                    font-size: 28px;
                  "
                  >Chanakya</span
                >
              </router-link>
            </v-flex>
            <v-flex xs2 xl1 pl-4 text-right align-self-center style="cursor:pointer">
              <AccountMenu />
            </v-flex>
    </v-layout>
     
      <!-- <v-toolbar-title>
        <router-link to="/">
          <v-layout wrap justify-center>
            <v-flex xs10 align-self-center text-left>
            <span
                  style="
                    font-family: GillSansUltraBold;
                    color: #3F033B;
                    font-size: 28px;
                  "
                  >JewelBIZ</span
                >
            </v-flex>
            <v-flex xs2 xl1 pl-4 text-right align-self-center style="cursor:pointer">
              <AccountMenu />
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title> -->
    </v-app-bar>
  </v-flex>
    <v-navigation-drawer v-model="sideNav" fixed temporary  src=".././assets/sidenav.png"
          overlay-color="white"  color="#3F033B">
          <v-flex xs12 py-6 align-self-center>
            <!-- <v-card tile height="70px" color="transparent"> -->
            <router-link to="/">
              <span style="
                      font-family: GillSansUltraBold;
                      color: white;
                      font-size: 25px;
                    ">Chanakya</span>
            </router-link>
            <!-- </v-card> -->
          </v-flex>
          <!---------------------------------- SuperAdmin sidebar-------------------------------------------->
          <v-layout wrap>
            <v-flex xs12 text-left text-uppercase align-self-center v-if="navItems">
           <v-layout wrap justify-center>
            <v-flex xs6 align-self-center pl-2 pb-3>
              <span v-if="appType == 'Staff'" @click="$router.push('/')" class="subhed text-none" style="color: #ffffff !important; cursor: pointer;">
                             Dashboard
                            </span>
            </v-flex>
           </v-layout>
              <v-list dense v-for="(main, i) in navItems" :key="i" class="subhed">
                <v-layout wrap>
                  <v-flex xs12 py-1>
                    <v-list-group no-action :value="false" active-class="activated">
                      <template v-slot:activator>
                        <v-list-item-icon>
                          <v-img height="20px" contain :src="main.menu.src"></v-img>
                        </v-list-item-icon>
                        <router-link :to="main.menu.route">
                            <span class="text-none subhed" style="color: #ffffff !important; cursor: pointer;">
                              {{ main.menu.name }}
                            </span>
                        </router-link>
                      </template>
                      <!-------------->
                    </v-list-group>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-flex>
            </v-layout>
        </v-navigation-drawer>
<!-- xs header -->
    
    </v-layout>
  </div>
</template>
<script>
import AccountMenu from "./../components/accountMenu";
import axios from "axios";
import store from "./../store";
export default {
  components: {
    AccountMenu,
    // SwitchAccount
  },
  data() {
    return {
      sideNav: false,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      menu2: [],
      
      userNavItemsSuperAdmin: [
        {
          menu: {
            name: "Dashboard",
            route: "/home",
            src: require("../assets/icons/send2.png"),
          
          },
        },
        // {
        //   menu: {
        //     name: "Election",
        //     route: "/ElectionType",
        //     src: require("../assets/icons/election2.png") ,
        //   },
        // },
        {
          menu: {
            name: "Political Party",
            route: "/PoliticalParty",
            src: require("../assets/icons/party.png"),
          },
        },
        {
          menu: {
            name: " President",
            route: "/addConstituencyPresident",
            src: require("../assets/icons/candidate.png"),
          },
        },
        // {
        //   menu: {
        //     name: "Aspirants",
        //     route: "/CandidateAspirants",
        //     src: require("../assets/icons/candidate.png"),
        //   },
        // },
        {
          menu: {
            name: "Constituency",
            route: "/addConstituency",
            src: require("../assets/icons/panchayat.png"),
          },
        },
        // {
        //   menu: {
        //     name: "Panchayat",
        //     route: "/addPanchayat",
        //     src: require("../assets/icons/parliament.png"),
        //   },
        // },
        // {
        //   menu: {
        //     name: "Ward",
        //     route: "/addWard",
        //     src: require("../assets/icons/ward.png"),
        //   },
        // },
        {
          menu: {
            name: "Booth",
            route: "/BoothList",
            src: require("../assets/icons/booth.png"),
          },
        },
        {
          menu: {
            name: "Voters List",
            route: "/VotersList",
            src: require("../assets/icons/voters.png"),
          },
        },
        // {
        //   menu: {
        //     name: "SETTINGS",
        //     route: "/MenuManagement",
        //     src: require("../assets/icons/settings.png"),
        //   },
        // },
      ],
    };
  },
  computed: {
    contentClass() {
      return this.$route.path === '/home' ? '' : 'pa-6';
    },
    appType() {
      return this.$store.state.userType;
    },
    userNavItemsStaffAdmin1(){
      return this.$store.state.menu;
    },
    navItems() {
      if (this.appType == "SuperAdmin") return this.userNavItemsSuperAdmin;
      else return this.userNavItemsStaffAdmin1;
  },
  isMPDashboardRoute() {
      return this.$route.path === '/home';
    },
  },
   methods: {
    appLogout() {
      axios({
        method: "get",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status==true) {
            this.$store.commit("logoutUser", true);
            localStorage.removeItem("id");
            // store.commit("menu", response.data.menus);
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: kumbhRegular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: kumbhRegular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
.v-list-group__header__append-icon {
  display: none !important;
}

@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky;
    /* Safari */
    position: sticky;
    top: 50;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}

/* .activated { */
.activated {
  color: rgba(63, 3, 59, 0.9) !important;
}

.deactivated {
  color: rgba(63, 3, 59, 0.9) !important;
}
</style>
